//@ts-nocheck

const copyCurrentUrl = () => {
	const copyUrlBtns = document.querySelectorAll(".js-copy-url-button");
	if (copyUrlBtns.length === 0) return;
	const messageBox = document.createElement("small");
	messageBox.classList.add("notification-message");
	document.body.append(messageBox);
	let url = document.location.href;

	copyUrlBtns.forEach((btn) => {
		let timeout;

		btn.addEventListener("click", () => {
			navigator.clipboard.writeText(url).then(
				() => {
					clearTimeout(timeout);
					messageBox.classList.remove("error");
					messageBox.classList.add("show");
					messageBox.innerText = "URL Copied!";
					timeout = setTimeout(() => {
						messageBox.classList.remove("show", "error");
					}, 4000);
				},
				() => {
					clearTimeout(timeout);
					messageBox.classList.add("show", "error");
					messageBox.innerText = "Something went wrong!";
					timeout = setTimeout(() => {
						messageBox.classList.remove("show", "error");
					}, 4000);
				}
			);
		});
	});
};

export default copyCurrentUrl;
